/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostClippingResearchBillingSuccessResponse
 */
export interface PostClippingResearchBillingSuccessResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PostClippingResearchBillingSuccessResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PostClippingResearchBillingSuccessResponse
     */
    message: string;
}

export function PostClippingResearchBillingSuccessResponseFromJSON(json: any): PostClippingResearchBillingSuccessResponse {
    return PostClippingResearchBillingSuccessResponseFromJSONTyped(json, false);
}

export function PostClippingResearchBillingSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostClippingResearchBillingSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function PostClippingResearchBillingSuccessResponseToJSON(value?: PostClippingResearchBillingSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

